export interface SubAccountPermission {
  id: string;
  label: string;
  description: string;
}

export interface SubAccountRole {
  id: string;
  name: string;
  defaultPermissions: string[];
}

export interface SubAccount {
  id: string;
  username: string;
  email: string;
  mobile: string;
  role: string;
  permissions: string[];
  status: 'active' | 'suspended' | 'pending';
  lastLogin: string;
  createdAt: string;
  createdBy: string;
}

export interface SubAccountFormData {
  username: string;
  email: string;
  mobile: string;
  password: string;
  role: string;
  permissions: string[];
}

export const AVAILABLE_PERMISSIONS: SubAccountPermission[] = [
  {
    id: 'manage_products',
    label: 'Manage Products',
    description: 'Create, edit, and delete product listings'
  },
  {
    id: 'manage_orders',
    label: 'Manage Orders',
    description: 'View and process customer orders'
  },
  {
    id: 'customer_inquiries',
    label: 'Customer Inquiries',
    description: 'Handle customer questions and support tickets'
  },
  {
    id: 'payments',
    label: 'Payments',
    description: 'Access payment information and financial data'
  },
  {
    id: 'analytics',
    label: 'Analytics',
    description: 'View business reports and analytics dashboard'
  },
  {
    id: 'team_management',
    label: 'Team Management',
    description: 'Manage sub-accounts and user permissions'
  }
];

export const SUB_ACCOUNT_ROLES: SubAccountRole[] = [
  {
    id: 'admin',
    name: 'Admin',
    defaultPermissions: ['manage_products', 'manage_orders', 'customer_inquiries', 'payments', 'analytics', 'team_management']
  },
  {
    id: 'sales',
    name: 'Sales',
    defaultPermissions: ['manage_products', 'manage_orders', 'customer_inquiries', 'analytics']
  },
  {
    id: 'support',
    name: 'Support',
    defaultPermissions: ['customer_inquiries']
  },
  {
    id: 'finance',
    name: 'Finance',
    defaultPermissions: ['payments', 'analytics']
  },
  {
    id: 'logistics',
    name: 'Logistics',
    defaultPermissions: ['manage_orders']
  }
];